<template>
    <div>
        <div>
            <div class="starsec"></div>
            <div class="starthird"></div>
            <div class="starfourth"></div>
            <div class="starfifth"></div>
        </div>

        <div class="lamp__wrap">
            <div class="lamp">
                <div class="cable"></div>
                <div class="cover"></div>
                <div class="in-cover">
                <div class="bulb"></div>
                </div>
                <div class="light"></div>
            </div>
        </div>

        <section class="error-information">
            <div class="error-information__content">
                <div class="error-information__message message">
                    <h1 class="message__title">{{ h1 }}</h1>
                    <p class="message__text">{{ p }}</p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        h1: {
            type: String,
            default: () => ''
        },
        p: {
            type: String,
            default: () => ''
        }
    }
}
</script>

<style src="./index.css" scoped />